export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_13.3b7abcb0.jpg";